import config from "environment";
import { getRequest, postRequest } from "./client";
import {
  CreatePaidTimeOffAdjustmentContract,
  DeletePaidTimeOffAdjustmentsByPolicyForWorkspaceContract,
  PaidTimeOffAdjustment,
  UpdatePaidTimeOffAdjustmentContract,
  UpdatePaidTimeOffAdjustmentsByPolicyForEmployeeRecordContract,
} from "winslow-core";

const { baseApi } = config;

export async function apiGetPaidTimeOffAdjustment(id: string): 
Promise<PaidTimeOffAdjustment | null> {
  const fetchURL = `${baseApi}/pto-adjustments/pto-adjustment/${id}`;
  return await getRequest(fetchURL, "API/apiGetPaidTimeOffAdjustment");
}

export async function apiGetPaidTimeOffAdjustmentsForWorkspace(workspaceId: string): 
Promise<PaidTimeOffAdjustment[] | null> {
  const fetchURL = `${baseApi}/pto-adjustments/workspace/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiGetPaidTimeOffAdjustmentsForWorkspace");
}

export async function apiGetPaidTimeOffAdjustmentsForEmployeeRecord(employeeRecordId: string): 
Promise<PaidTimeOffAdjustment[] | null> {
  const fetchURL = `${baseApi}/pto-adjustments/employee-record/${employeeRecordId}`;
  return await getRequest(fetchURL, "API/apiGetPaidTimeOffAdjustmentsForEmployeeRecord");
}

export async function apiCreatePaidTimeOffAdjustment(
  payload: CreatePaidTimeOffAdjustmentContract["Body"]
): Promise<PaidTimeOffAdjustment | null> {
  const fetchURL = `${baseApi}/pto-adjustments/create`;
  return await postRequest(fetchURL, payload, "API/apiCreatePaidTimeOffAdjustment");
}

export async function apiUpdatePaidTimeOffAdjustment(
  payload: UpdatePaidTimeOffAdjustmentContract["Body"]
): Promise<PaidTimeOffAdjustment | null> {
  const fetchURL = `${baseApi}/pto-adjustments/update`;
  return await postRequest(fetchURL, payload, "API/apiUpdatePaidTimeOffAdjustment");
}
  
export async function apiDeletePaidTimeOffAdjustment(id: string): 
Promise<PaidTimeOffAdjustment | null> {
  const fetchURL = `${baseApi}/pto-adjustments/delete/${id}`;
  return await getRequest(fetchURL, "API/apiGetPaidTimeOffAdjustment");
}

export async function apiDeletePaidTimeOffAdjustmentsByPolicyForWorkspace(
    payload: DeletePaidTimeOffAdjustmentsByPolicyForWorkspaceContract["Body"]
  ): Promise<PaidTimeOffAdjustment | null> {
    const fetchURL = `${baseApi}/pto-Aajustments/delete-by-policy`;
    return await postRequest(fetchURL, payload, "API/apiDeletePaidTimeOffAdjustmentsByPolicyForWorkspace")
}

